export default __webpack_public_path__ + "locales/bg/Ldap.json?hash=5a9eb6d3045ed22658b0d038d5b256db";